import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="py-24 px-4 bg-sage-50" data-id="element-323" data-mp="coiu4r4d9dov">
      <div className="max-w-6xl mx-auto" data-id="element-324" data-mp="cn7sawuheg0e">
        <div className="text-center mb-16" data-id="element-325" data-mp="cm510nt8ybjy">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-4 text-forest" data-id="element-326" data-mp="7qhbu8erlieg">
            THE 6-IN-1 HYDROPONICS GROWER <span className="text-leaf" data-id="element-327" data-mp="3g5r8v23srxfd">READY</span> SYSTEM
          </h2>
          <p className="text-xl text-charcoal/80" data-id="element-328" data-mp="3c4fkezwnti8r">
            Setup · Nutrients · Roots · Crops · Environment · Troubleshooting
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-329" data-mp="3pwvrcbsom0ey">
          {volumes.map((volume, index) => <motion.article key={volume.number} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white rounded-2xl border ${volume.popular ? 'border-2 border-leaf shadow-lg shadow-forest/10' : 'border-sage-200 shadow-sm shadow-forest/5'} p-8 relative overflow-hidden flex flex-col h-full`} data-id="element-330" data-mp="3l2hojobowr09" data-mpi={index}>
              {volume.popular && <div className="absolute top-7 right-[-44px] bg-leaf text-white font-bold text-xs py-1 px-10 rotate-45 shadow whitespace-nowrap" data-id="element-331" data-mp="1qh6596y5cu96">
                  {volume.popularLabel ?? 'MOST POPULAR'}
                </div>}

              <div className="flex items-center gap-4 mb-6 pr-10" data-id="element-332" data-mp="20ditvqeu4hx2">
                <span className="w-12 h-12 rounded-xl bg-forest text-white font-extrabold text-2xl flex items-center justify-center shrink-0" aria-hidden="true" data-id="element-333" data-mp="24hgu64fwbyrp">
                  {index + 1}
                </span>
                <div data-id="element-334" data-mp="1gqt0h5gbci3o">
                  <div className="text-leaf font-bold text-sm uppercase tracking-wider" data-id="element-335" data-mp="1gq1emmcipyql">
                    {volume.number}
                  </div>
                  <h3 className="text-2xl font-bold tracking-tight leading-tight mt-1 text-forest" data-id="element-336" data-mp="1btu6cmwngb5h">
                    {volume.title}
                  </h3>
                </div>
              </div>

              <p className="text-forest font-semibold mb-6 border-l-4 border-leaf pl-4" data-id="element-337" data-mp="1kqbhvr8xeb1r">
                {volume.subtitle}
              </p>

              {(volume.intro.length > 0 || volume.questions || volume.highlight) && <div className="mb-6 space-y-2" data-id="element-338" data-mp="16sd70vttcwr0">
                  {volume.intro.map(paragraph => <p key={paragraph} className="text-charcoal text-sm leading-relaxed" data-id="element-339" data-mp="121en7m9m9gj0">
                      {paragraph}
                    </p>)}
                  {volume.questions && <ul className="grid sm:grid-cols-2 gap-2 pt-1" data-id="element-340" data-mp="9e0z8dnwbvb1">
                      {volume.questions.map(question => <li key={question} className="text-forest font-semibold text-sm bg-sage-50 border border-sage-200 rounded-lg px-3 py-2" data-id="element-341" data-mp="2kz1iietbfklg">
                          {question}
                        </li>)}
                    </ul>}
                  {volume.highlight && <p className="text-forest font-bold text-base bg-lime-soft border-l-4 border-leaf rounded-lg px-4 py-3" data-id="element-342" data-mp="34p3hq59dwcth">
                      {volume.highlight}
                    </p>}
                  {volume.afterHighlight && <p className="text-charcoal text-sm leading-relaxed" data-id="element-343" data-mp="2zoza74qgesfe">{volume.afterHighlight}</p>}
                </div>}

              <div data-id="element-344" data-mp="1j9xs75c6dg0x">
                <div data-id="element-345" data-mp="1oabz2k21ijxd">
                  <p className="text-forest font-semibold text-sm mb-3" data-id="element-346" data-mp="1oav7991w1ty7">{volume.bulletsIntro}</p>
                  <ul className={`mb-6 ${volume.bullets.length > 10 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start' : 'space-y-3'}`} data-id="element-347" data-mp="23kif7t1a4101">
                    {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-348" data-mp="1ptvexwfve31u">
                        <CheckCircle2 size={18} className="text-leaf shrink-0 mt-0.5" data-id="element-349" data-mp="2mjcqut5g4lbz" />
                        <span className="text-charcoal text-sm" data-id="element-350" data-mp="2ihixl5xkyjlu">{bullet}</span>
                      </li>)}
                  </ul>
                </div>

                {volume.secondaryBullets && <div data-id="element-351" data-mp="28juyy4wusrye">
                    <p className="text-forest font-semibold text-sm mb-3" data-id="element-352" data-mp="28ijwc8f59q8v">
                      {volume.secondaryBulletsIntro}
                    </p>
                    <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-3 content-start" data-id="element-353" data-mp="x46bzdjlnsxl">
                      {volume.secondaryBullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-354" data-mp="n1sx1z8t9pda">
                          <CheckCircle2 size={18} className="text-leaf shrink-0 mt-0.5" data-id="element-355" data-mp="rzuhanhz3uqc" />
                          <span className="text-charcoal text-sm" data-id="element-356" data-mp="wx4ckjs1n0m3">{bullet}</span>
                        </li>)}
                    </ul>
                  </div>}
              </div>

              {volume.sequence && <div className="mb-6" data-id="element-357" data-mp="1apka5526e6fm">
                  <p className="text-forest font-semibold text-sm mb-2" data-id="element-358" data-mp="1aoizh1p2nlyf">{volume.sequenceIntro}</p>
                  <p className="text-forest font-bold text-sm bg-lime-soft border border-sage-200 rounded-lg px-3 py-2" data-id="element-359" data-mp="1fporsyetl77f">
                    {volume.sequence}
                  </p>
                </div>}

              <div className="bg-sage-50 border border-sage-200 border-l-4 border-l-leaf rounded-xl p-4 mt-auto" data-id="element-360" data-mp="3hhl1e2hfg6zk">
                <span className="text-forest font-bold block mb-1" data-id="element-361" data-mp="3mfd29m01v3fw">RESULT</span>
                {volume.resultLead && <p className="text-charcoal text-sm" data-id="element-362" data-mp="39fc2w7v0je4j">
                    {volume.resultLead}{' '}
                    <span className="font-semibold text-forest" data-id="element-363" data-mp="3oclbeecg6yjh">{volume.resultQuote}</span>
                  </p>}
                <p className="text-charcoal text-sm" data-id="element-364" data-mp="3jd8mlo20nhe9">{volume.result}</p>
                {volume.resultEmphasis && <p className="mt-2 text-xl font-extrabold tracking-tight text-leaf" data-id="element-365" data-mp="16kju4ufv6br">
                    {volume.resultEmphasis}
                  </p>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}